export const listeordersPath = '';
export const ordersBasePath = 'commandes';
export const orderDetailPath = ':idOrder';
